import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import DateFormat from '../../store/types/enums/DateFormat'

export type MixDatesTopographyType = {
  futureSelectedRows: string[]
  pastSelectedRows: string[]
}


export const MixDatesTopography = ({ futureSelectedRows, pastSelectedRows }: MixDatesTopographyType) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography>{t('page.schedule.deleteManyPopup.deleteConfirmationQuestion')}</Typography>
      <Typography>
        {t('page.schedule.deleteManyPopup.recordsToBeDeleted')} {futureSelectedRows.length}
      </Typography>
      <Box sx={{ display: 'flex', gap: '10px', padding: '36px', flexWrap: 'wrap' }}>
        <Box>
          {futureSelectedRows.map((date, index) => {
            return (
              <Typography key={index} display={'flex'} flexDirection={'column'}>
                {dayjs(date).format(DateFormat.YearMonthDayBracketDayFullName)}
              </Typography>
            )
          })}
        </Box>
      </Box>
      <Typography>{t('page.schedule.deleteManyPopup.deleteConfirmationQuestionForOnlyPast')}</Typography>
      <Box sx={{ display: 'flex', gap: '10px', padding: '36px', flexWrap: 'wrap' }}>
        <Box>
          {pastSelectedRows.map((date, index) => {
            return (
              <Typography key={index} display={'flex'} flexDirection={'column'}>
                {dayjs(date).format(DateFormat.YearMonthDayBracketDayFullName)}
              </Typography>
            )
          })}
        </Box>
      </Box>
    </>
  )
}